import type { TextProps } from '@vesyl/ui/chakra'
import { Text } from '@vesyl/ui/chakra'
import { useUserStore } from '../../../store'
import { ozToUserUnit } from '../../../utils/localization'

export type WeightTextProps = TextProps & {
  value: number
}

export function WeightText(props: WeightTextProps) {
  const { value, ...rest } = props

  const weightUnit = useUserStore((state) => state.weightUnit) || 'oz'

  let weight = ozToUserUnit(value, weightUnit)
  let formatted = ''

  if (weightUnit === 'oz') {
    if (weight >= 16) {
      const pounds = Math.floor(weight / 16)
      const oz = (weight % 16).toFixed(0)
      formatted = `${pounds} lb ${Number(oz) > 0 ? `${oz} oz` : ''}`
    } else {
      const oz = weight % 1 !== 0 ? weight.toFixed(1) : weight.toFixed(0)
      formatted = `${oz} oz`
    }
  } else {
    if (weight >= 1000) {
      formatted = `${(weight / 1000).toFixed(3)} kg`
    } else {
      formatted = `${weight.toFixed(0)} g`
    }
  }

  return <Text {...rest}>{formatted}</Text>
}
